"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.nodeRipemd160 = exports.nodeSha512 = exports.nodeSha256 = exports.nodeHmacSha512Sign = exports.nodeHmacSha256Sign = exports.nodeAesDecrypt = exports.nodeAesEncrypt = exports.nodeRandomBytes = void 0;

var crypto_1 = __importDefault(require("crypto"));

var enc_utils_1 = require("enc-utils");

var constants_1 = require("../constants");

function nodeRandomBytes(length) {
  var buf = crypto_1.default.randomBytes(length);
  return enc_utils_1.bufferToArray(buf);
}

exports.nodeRandomBytes = nodeRandomBytes;

function nodeAesEncrypt(iv, key, data) {
  var cipher = crypto_1.default.createCipheriv(constants_1.AES_NODE_ALGO, key, iv);
  return enc_utils_1.bufferToArray(enc_utils_1.concatBuffers(cipher.update(data), cipher.final()));
}

exports.nodeAesEncrypt = nodeAesEncrypt;

function nodeAesDecrypt(iv, key, data) {
  var decipher = crypto_1.default.createDecipheriv(constants_1.AES_NODE_ALGO, key, iv);
  return enc_utils_1.bufferToArray(enc_utils_1.concatBuffers(decipher.update(data), decipher.final()));
}

exports.nodeAesDecrypt = nodeAesDecrypt;

function nodeHmacSha256Sign(key, data) {
  var buf = crypto_1.default.createHmac(constants_1.HMAC_NODE_ALGO, new Uint8Array(key)).update(data).digest();
  return enc_utils_1.bufferToArray(buf);
}

exports.nodeHmacSha256Sign = nodeHmacSha256Sign;

function nodeHmacSha512Sign(key, data) {
  var buf = crypto_1.default.createHmac(constants_1.SHA512_NODE_ALGO, new Uint8Array(key)).update(data).digest();
  return enc_utils_1.bufferToArray(buf);
}

exports.nodeHmacSha512Sign = nodeHmacSha512Sign;

function nodeSha256(data) {
  var buf = crypto_1.default.createHash(constants_1.SHA256_NODE_ALGO).update(data).digest();
  return enc_utils_1.bufferToArray(buf);
}

exports.nodeSha256 = nodeSha256;

function nodeSha512(data) {
  var buf = crypto_1.default.createHash(constants_1.SHA512_NODE_ALGO).update(data).digest();
  return enc_utils_1.bufferToArray(buf);
}

exports.nodeSha512 = nodeSha512;

function nodeRipemd160(data) {
  var buf = crypto_1.default.createHash(constants_1.RIPEMD160_NODE_ALGO).update(data).digest();
  return enc_utils_1.bufferToArray(buf);
}

exports.nodeRipemd160 = nodeRipemd160;